import {apiPost} from './api';

export default class ServicioReportes {
  static obtenerReportes(filtros) {
    return apiPost('/reportedinamico/Reportes', filtros);
  }

  static obtenerFiltrosReporte(reporteID) {
    const data = {
      CatalogoReporteID: reporteID,
    };
    return apiPost('/reportedinamico/ReporteFiltros', data);
  }

  static obtenerReporte(sp, metodo, datos) {
    const data = {
      SP: sp,
      Metodo: metodo,
      Datos: JSON.stringify(datos),
    };
    return apiPost('/general/EjecutarSP', data);
  }
}
